import { fetch } from "../utils/scsFetch";
import { URL_SURVEY_API, REACT_APP_URL_SURVEY_API_EXT } from '../utils/constEnvVariables'

export const submitSurvey = function (request, accessToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }
    return fetch(`${URL_SURVEY_API}/surveys/campaign/${request.id}`, requestOptions)
    .then(response => {
        return response
    })
    .catch(error => { throw error });
}

export const submitSurveyExt = function(request,token) {
    const requestOptions = { method: 'PATCH', headers: { 'Authorization': `Bearer ${token}` }, body: JSON.stringify(request) }
    return fetch(`${URL_SURVEY_API}/surveys-ext/COC/campaign/${request.id}`, requestOptions)
    .then(response => {
        return response
    })
    .catch(error => { throw error });
}

export const getCampaigsByRn = function (rn, accessToken) {
    let pathParam = "surveys";
    let requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };

    return fetch(`${URL_SURVEY_API}/${pathParam}/campaign/assignment/${rn}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getActiveSurveys = function (accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    return fetch(`${URL_SURVEY_API}/surveys`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getSelfServiceSurveys = function (accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }
    return fetch(`${URL_SURVEY_API}/surveys/selfServiceSurveys`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const postAllOpenCampaigns = function (accessToken) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/campaign/all`, requestOptions);

}

export const postAllCampaignsAssignments = function (accessToken, supplierNumbers) {
    if (!supplierNumbers || supplierNumbers.length <= 0) {
        supplierNumbers = []
    }
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(supplierNumbers)
    }
    return fetch(`${URL_SURVEY_API}/surveys/campaign/allassignments`, requestOptions);

}

export const closeCampaign = (accessToken, campaign) => {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(campaign)
    }

    return fetch(`${URL_SURVEY_API}/surveys/campaign/${campaign.id}`, requestOptions).then(response => {
        return response
    }).catch(err => { return err });
}

export const getCampaignResponses = (campaign, accessToken) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${REACT_APP_URL_SURVEY_API_EXT}/surveys/campaign/responses/${campaign.surveyId}&${campaign.id}`, requestOptions)
        .then(response => { return response }).catch(err => { return err });
}

export const deleteAssignment = (assignmentId, accessToken) => {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/campaign/assignment/${assignmentId}`, requestOptions)
        .then(response => { return response }).catch(err => { return err });
}

export const updateAssignmentStatus = function (request, accessToken){
    const requestOptions = {
        method: 'PATCH',
        headers:{
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            id: request.id,
            status: request.status,
            updatedBy: request.updatedBy
        })
    }
    return fetch(`${URL_SURVEY_API}/surveys/campaign/assignment`, requestOptions)
    .then(response => {
        return response
    })
    .catch(error => {throw error});
}

export const saveContactData = function (request, accessToken) {
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(request),
    };
  
    return fetch(`${URL_SURVEY_API}/surveys/subtier/saveContactData`, requestOptions)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
};
export const saveNonDeereContactData = function (request, accessToken) {
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(request),
    };
  
    return fetch(`${URL_SURVEY_API}/surveys/subtier/saveNonDeereContactData`, requestOptions)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
};

  export const getCampaignContacts = (assignmentId, accessToken) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/subtier/getContactData/${assignmentId}`, requestOptions)
        .then(response => { 
            return response 
        }).catch(err => { 
            console.log(err);
            return [] 
        });
}

export const getNonDeereContactData = (assignmentId, accessToken) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/subtier/getNonDeereContactData/${assignmentId}`, requestOptions)
        .then(response => { 
            return response 
        }).catch(err => { 
            console.log(err);
            return [] 
        });
}

export const deleteCampaignContacts = (req, accessToken) => {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/subtier/deleteContact/${req.assignmentId}/${req.id}`, requestOptions)
        .then(response => { 
            return response 
        }).catch(err => { 
            console.log(err);
            return [] 
        });
}

export const deleteCampaignNonDeereContacts = (req, accessToken) => {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/subtier/deleteNonDeereContact/${req.assignmentId}/${req.id}`, requestOptions)
        .then(response => { 
            return response 
        }).catch(err => { 
            console.log(err);
            return [] 
        });
}

export const getSupplierContacts = (supplierNo, campaignId, accessToken) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }
    return fetch(`${URL_SURVEY_API}/surveys/subtier/search/${campaignId}/${supplierNo}`, requestOptions)
        .then(response => { 
            return response 
        }).catch(err => { 
            console.log(err);
            return [] 
        });
}

export const addSupplierToCampaign = (request, accessToken) => {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request),
    }
    return fetch(`${URL_SURVEY_API}/surveys/campaign/add/newsupplier`, requestOptions).then((response) => {
        return response;
    }).catch((error) => {
        throw error;
    });
}

export const deleteResponseFromAssignment = (assignmentId, accessToken) => {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/aeu/response/${assignmentId}`, requestOptions)
        .then(response => { return response }).catch(err => { return err });
}

export const savePartsForSurvey = (accessToken, reqObj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(reqObj),
    }
    return fetch(`${URL_SURVEY_API}/surveys/campaign/addParts`, requestOptions).then((response) => {
        return response;
    }).catch((error) => {
        throw error;
    });
}

export const sendEmailNotification = async (campaignId, assignmentId, supplierNumber, supplierName, deereContacts, companyContacts, deereSupplierContacts,nonDeereSupplierContacts, accessToken) => {
    const url = `${URL_SURVEY_API}/surveys/campaign/emailNotifications`; 
    const payload = {
      campaignId: campaignId,
      assignments: [
        {
            assignmentId: assignmentId,
            supplierNumber: supplierNumber,
            supplierName: supplierName,
            companyContacts: companyContacts,
            deereContacts: deereContacts,
            deereSupplierContacts: deereSupplierContacts,
            nonDeereSupplierContacts: nonDeereSupplierContacts
        }
      ],
    };
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        body: JSON.stringify(payload),
    }
  
    return  fetch(url, requestOptions)
        .then(response => {
            return response;
        }).catch((error) => {
            throw error;
        });
  };
